// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Center, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import type { JSX } from 'react';

export function PatientListEmptyState(): JSX.Element {
  return (
    <Center h="100%" p="xl">
      <Stack align="center" gap="xs">
        <ThemeIcon variant="light" size={64} radius="xl">
          <IconUser size={32} />
        </ThemeIcon>
        <Text fw={600}>Select a patient</Text>
        <Text c="dimmed" size="sm">
          Pick a patient from the list to view their chart.
        </Text>
      </Stack>
    </Center>
  );
}
